import { getAPIendpointPrefix } from './apiHelper';
import { axiosWithRetry } from '../../shared/lib/axios';

import {
    NETWORK_STATUS_UP,
    NETWORK_STATUS_DOWN,
  } from '.'

export const checkNetworkStatus = async (dispatch, getState) => {
    const { core: { config: { LC_GRADE_SERVICE_URL, FF_USE_LC_GRADE_SERVICE }}} = getState();
    const apiEndpoint = FF_USE_LC_GRADE_SERVICE === 'true' ? `${LC_GRADE_SERVICE_URL}/` : getAPIendpointPrefix()

    try{
        // Check the status of the application
        let response = await axiosWithRetry({
            url: apiEndpoint + 'status',
            method: 'GET'
        });

        // Update network status as per response from the status
        if (response.status === 200) {
            dispatch({ type: NETWORK_STATUS_UP});
        }
        else {
            dispatch({ type: NETWORK_STATUS_DOWN});
        }
    } catch (error) {
        console.error(error);
        dispatch({ type: NETWORK_STATUS_DOWN });
    }
}